// src/components/BookCarousel.js
import React, { useRef, useState, useEffect } from "react";
import BookCard from "./BookCard";
import "../styles/BookCarousel.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

const BookCarousel = ({ title, books }) => {
  const containerRef = useRef(null);
  const firstSlideRef = useRef(null);
  const [slideWidth, setSlideWidth] = useState(0);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [hovered, setHovered] = useState(false);

  const updateArrows = () => {
    const container = containerRef.current;
    if (!container) return;
    setShowLeft(container.scrollLeft > 0);
    setShowRight(container.scrollLeft + container.clientWidth < container.scrollWidth - 5);
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    updateArrows();
    container.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      container.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);

  useEffect(() => {
    if (firstSlideRef.current) {
      const slide = firstSlideRef.current;
      const style = window.getComputedStyle(slide);
      const marginRight = parseInt(style.marginRight) || 0;
      setSlideWidth(slide.offsetWidth + marginRight);
    }
  }, [books]);

  return (
    <div
      className="carousel-section"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <h2 className="carousel-title">{title}</h2>
      <div className="carousel-wrapper">
        {hovered && showLeft && (
          <button
            className="carousel-arrow left"
            onClick={() =>
              containerRef.current.scrollBy({ left: -slideWidth, behavior: "smooth" })
            }
          >
            <ChevronLeft size={28} strokeWidth={2.5} />
          </button>
        )}
        <div className="carousel-container" ref={containerRef}>
          {books.map((book, index) => (
            <div
              className="book-slide"
              key={index}
              ref={index === 0 ? firstSlideRef : null}
            >
              <BookCard book={book} />
            </div>
          ))}
        </div>
        {hovered && showRight && (
          <button
            className="carousel-arrow right"
            onClick={() =>
              containerRef.current.scrollBy({ left: slideWidth, behavior: "smooth" })
            }
          >
            <ChevronRight size={28} strokeWidth={2.5} />
          </button>
        )}
      </div>
    </div>
  );
};

export default BookCarousel;
